import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AuthenticationService } from '../authentication.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss'],
  providers: [MessageService],
})
export class ForgotComponent implements OnInit {
  form: any = {};
  error: string | undefined;
  forgotPassForm!: FormGroup;
  isLoading = false;
  blocked: boolean;
  confirmMessage: string;
  confirmMessageSummary: string;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.createForm();
  }

  ngOnInit(): void {}

  goBack() {
    this.router.navigate(['/login']);
    // this.location.back();
  }

  onSubmit(): void {
    //submit forgot password form
    this.blocked = true;
    this.authenticationService.forgotPassword(this.forgotPassForm.value).subscribe(
      (res: any) => {
        this.blocked = false;
        this.confirmMessage = this.translate.instant('Forgot-Password-Message');
        this.confirmMessageSummary = this.translate.instant('ForgotPWD-MSGSummary');
        this.messageService.add({
          key: 'c',
          sticky: true,
          severity: 'success',
          summary: this.confirmMessage,
          detail: this.confirmMessageSummary,
        });
        // this.messageService.add({
        //   key: 'forgot',
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: 'Temporary password has been sent to your email.Please check your email!.',
        // });
      },
      (err) => {
        if (err.status === 400) {
          this.blocked = false;
          this.messageService.add({
            key: 'forgot',
            severity: 'error',
            summary: 'Error',
            detail: err.message,
          });
        } else {
          this.blocked = false;
          this.confirmMessage = this.translate.instant('Forgot-Password-Message');
          this.confirmMessageSummary = this.translate.instant('ForgotPWD-MSGSummary');
          this.messageService.add({
            key: 'c',
            sticky: true,
            severity: 'success',
            summary: this.confirmMessage,
            detail: this.confirmMessageSummary,
          });
        }
      }
    );
  }
  /**
   * on closing dialogue
   */
  onReject() {
    this.messageService.clear('c');
    this.router.navigate(['/login']);
  }
  private createForm() {
    //create forgot password form
    this.forgotPassForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            "^$|^([\\w-']+(?:\\.[\\w-']+)*)@((?:[\\w-]+\\.)*\\w[\\w-]+)\\.([a-zA-Z]+(?:\\.[a-zA-Z]+)?)$"
          ),
        ],
      ],
    });
  }
}
